const Loading = () => (
    <div className="loading-wrapper">
        <div className="loading" />
    </div>
);

export default Loading;
